export function flipCoordinates(flip, baseImage, scale) {
    const rotation = baseImage.rotation();
    let x = baseImage.x();
    let y = baseImage.y();
    const flipData = {
        x,
        y,
    };
    switch (rotation) {
        case 90:
            if (scale.x === -1) {
                y = baseImage.y() + baseImage.width();
            }
            else {
                y = baseImage.y() - baseImage.width();
            }
            if (scale.y === -1) {
                x = baseImage.x() - baseImage.height();
            }
            else {
                x = baseImage.x() + baseImage.height();
            }
            if (flip == 'v') {
                flipData.x = x;
            }
            else if (flip == 'h') {
                flipData.y = y;
            }
            else if (flip == 'b') {
                flipData.x = x;
                flipData.y = y;
            }
            break;
        case 180:
        case -180:
            if (scale.y === -1) {
                y = baseImage.height() - baseImage.y();
            }
            else {
                y = baseImage.y() + baseImage.height();
            }
            if (scale.x === -1) {
                x = baseImage.x() - baseImage.width();
            }
            else {
                x = baseImage.x() + baseImage.width();
            }
            if (flip == 'v') {
                flipData.y = y;
            }
            else if (flip == 'h') {
                flipData.x = x;
            }
            else if (flip == 'b') {
                flipData.x = x;
                flipData.y = y;
            }
            break;
        case 270:
            if (scale.x === -1) {
                y = baseImage.y() - baseImage.width();
            }
            else {
                y = baseImage.y() + baseImage.width();
            }
            if (scale.y === -1) {
                x = baseImage.height() + baseImage.x();
            }
            else {
                x = baseImage.x() - baseImage.height();
            }
            if (flip == 'v') {
                flipData.x = x;
            }
            else if (flip == 'h') {
                flipData.y = y;
            }
            else if (flip == 'b') {
                flipData.x = x;
                flipData.y = y;
            }
            break;
        case -90:
            if (scale.x === -1) {
                y = baseImage.y() - baseImage.width();
            }
            else {
                y = baseImage.y() + baseImage.width();
            }
            if (scale.y === -1) {
                x = baseImage.x() + baseImage.height();
            }
            else {
                x = baseImage.x() - baseImage.height();
            }
            if (flip == 'v') {
                flipData.x = x;
            }
            else if (flip == 'h') {
                flipData.y = y;
            }
            else if (flip == 'b') {
                flipData.x = x;
                flipData.y = y;
            }
            break;
        case -270:
            if (scale.x === -1) {
                y = baseImage.width() + baseImage.y();
            }
            else {
                y = baseImage.y() - baseImage.width();
            }
            if (scale.y === -1) {
                x = baseImage.x() - baseImage.height();
            }
            else {
                x = baseImage.x() + baseImage.height();
            }
            if (flip == 'v') {
                flipData.x = x;
            }
            else if (flip == 'h') {
                flipData.y = y;
            }
            else if (flip == 'b') {
                flipData.x = x;
                flipData.y = y;
            }
            break;
        default:
            if (scale.y === -1) {
                y = baseImage.height() + baseImage.y();
            }
            else {
                y = baseImage.y() - baseImage.height();
            }
            if (scale.x === -1) {
                x = baseImage.x() + baseImage.width();
            }
            else {
                x = baseImage.x() - baseImage.width();
            }
            if (flip == 'v') {
                flipData.y = y;
            }
            else if (flip == 'h') {
                flipData.x = x;
            }
            else if (flip == 'b') {
                flipData.x = x;
                flipData.y = y;
            }
    }
    return flipData;
}
